export default "__VITE_ASSET__b3cbe112__"